// import {use_mock_api} from "../env";
import {apiFetchCarModelDetails, apiFetchCarModelDetailsNew, apiSubmitApplication} from "../apis/calculator";

import {actionFromError} from "./ActionUtils";

import modelDetailData from '../mock_apis/model-detail-data';

import { HttpError } from "../errors/Errors";
const use_mock_api = false;


export const actions='';

// action type a string
export const CHANGE_UI = 'CONFIGURATOR/CHANGE_UI';

export const changeUI = (uiControlName, value) => ({type: CHANGE_UI, payload: {uiControlName, value}})

// action type a string
export const CHANGE_FIELD = 'CONFIGURATOR/CHANGE_FIELD';

// pure / static action factory
export const changeField = (fieldName, value) => {
    return (dispatch, getState) => {
        let action = { // action in redux - a pure javascript object
            type: CHANGE_FIELD,
            payload: {fieldName, value}
        };
        dispatch(action);

        const {entities, form, ui} = getState().calculator;

        switch (fieldName) {
            case 'carModel':
                dispatch({ type: CHANGE_FIELD, payload: {fieldName: 'color', value: null}});
                dispatch({ type: CHANGE_FIELD, payload: {fieldName: 'trim', value: null}});
                dispatch({ type: CHANGE_FIELD, payload: {fieldName: 'package', value: null}});
                dispatch(changeUI('colors', entities.carModels[value].colorList));
                break;

            case 'color':
                dispatch({ type: CHANGE_FIELD, payload: {fieldName: 'trim', value: null}});
                dispatch({ type: CHANGE_FIELD, payload: {fieldName: 'package', value: null}});

                dispatch(changeUI('trims', entities.colors[value].trimList));
                break;
            case 'trim':
                dispatch({ type: CHANGE_FIELD, payload: {fieldName: 'package', value: null}});
                let packages = entities.trims[value].packageList;
                dispatch(changeUI('packages', packages));
                break;
            case 'option':
                break;
            default:
                break;
        }

        dispatch(prefillFormIfPossible()); // review this later, bad design , which can cause infinite loop
    }
};


export const FETCH_CAR_MODEL_DETAILS = 'CONFIGURATOR/FETCH_CAR_MODEL_DETAILS';

// pure action factory
export const fetchCarModelDetailsSuccess = (payload) => ({type: FETCH_CAR_MODEL_DETAILS, payload});
// pure action factory
export const fetchCarModelDetailsFailure = (error) => ({type: FETCH_CAR_MODEL_DETAILS, error});

// async / dynamic action factory
export const fetchCarModelDetails = (variantId, isNew, context) => {
    return (dispatch) => {
        if (use_mock_api) {
            return dispatch(fetchCarModelDetailsSuccess(modelDetailData))
        } else {
            return apiFetchCarModelDetailsNew({
                variantId,
                isNew
            }, context)
                .then(function (data) {
                    return dispatch(fetchCarModelDetailsSuccess(data))
                }).catch((e) => {
                    return dispatch((actionFromError(FETCH_CAR_MODEL_DETAILS, e)))
                });
        }
    }
};

// async / dynamic action factory
export const prefillFormIfPossible = () => {
    return (dispatch, getState) => {
        let state = getState();
        let {form, ui} = state.calculator;

        function fetchFreshState() {
            state = getState();
            form = state.calculator.form;
            ui = state.calculator.ui;
        }

        if (!form.carModel && ui.carModels.length >= 1) {
            dispatch(changeField('carModel', ui.carModels[0]))

            fetchFreshState();
        }

        if (!form.color && ui.colors.length >= 1) {
            dispatch(changeField('color', ui.colors[0]))

            fetchFreshState();
        }

        if (!form.trim && ui.trims.length >= 1) {
            dispatch(changeField('trim', ui.trims[0]))

            fetchFreshState();
        }

        if (!form.package && ui.packages.length >= 1) {
            dispatch(changeField('package', ui.packages[0]))
        }

    }
}

// async / dynamic action factory
export const submit = () => {
  return (dispatch, getState) => {
    let state = getState();
    const {form, ui, entities} = state.calculator;
    const context = state.context;
    console.log(state);
    return apiSubmitApplication({
      id: form.package,
      desiredMonth: '2019-09-18T09:09:51.471Z'
    }, context)
      .then(function (data) {
        return data;
      }).catch((e) => {
        e.message = "The selected vehicle is not available anymore. Please select other vehicle.";
        dispatch((actionFromError('submit', e)));
        // return {
        //     error: true,
        // }
      });
  }
}

// async / dynamic action factory

export const RESET_FORM = 'CONFIGURATOR/RESET_FORM';
export const resetForm = () => ({type: RESET_FORM});

export const RESET_UI = 'CONFIGURATOR/RESET_UI';
export const resetUI = () => ({type: RESET_UI});


// WEBPACK FOOTER //
// ./src/actions/calculator.js